/**
 * @generated SignedSource<<143560448a1145e3251053a6ec392dad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpSaleUrgencyBannerVariant_displayPrice$data = ReadonlyArray<{
  readonly amountType: string | null;
  readonly " $fragmentType": "usePdpSaleUrgencyBannerVariant_displayPrice";
}>;
export type usePdpSaleUrgencyBannerVariant_displayPrice$key = ReadonlyArray<{
  readonly " $data"?: usePdpSaleUrgencyBannerVariant_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpSaleUrgencyBannerVariant_displayPrice">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "usePdpSaleUrgencyBannerVariant_displayPrice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "b7e160c0fb1ae1d534750aab8c868802";

export default node;
